import Section from '../components/shared/Section'
import BookingWidget from '../components/shared/BookingWidget'
import SEO from '../components/shared/SEO'
import { ROUTE_META } from '../lib/seo'
import { Mail, Linkedin } from 'lucide-react'

export default function Contact() {
  return (
    <>
      <SEO
        title={ROUTE_META['/contact'].title}
        description={ROUTE_META['/contact'].description}
        jsonLd={ROUTE_META['/contact'].jsonLd}
      />

      {/* Hero + Booking Widget */}
      <Section>
        <div className="text-center max-w-4xl mx-auto mb-10">
          <h1 className="text-5xl md:text-6xl text-neon-purple mb-6">
            Let's talk about what you're building.
          </h1>
          <p className="text-xl text-neutral-400">
            Book a discovery call below, or get in touch directly.
          </p>
        </div>
        <div id="booking" className="max-w-xl mx-auto">
          <div className="bg-dark-800 border border-neon-lime/20 rounded-xl overflow-hidden hover:border-neon-lime/40 transition-all duration-300">
            <BookingWidget slug="discovery" />
          </div>
        </div>
      </Section>

      {/* Alternative Contact Section */}
      <Section background="gray">
        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-2xl text-neon-orange mb-6">
            Prefer email?
          </h3>
          <div className="space-y-4">
            <a
              href="mailto:hello@mathosconsult.com"
              className="flex items-center justify-center gap-3 text-lg text-neon-pink hover:text-neon-purple transition-colors"
            >
              <Mail size={24} />
              hello@mathosconsult.com
            </a>
            <a
              href="https://linkedin.com/company/mathosconsult"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 text-lg text-neon-pink hover:text-neon-purple transition-colors"
            >
              <Linkedin size={24} />
              LinkedIn
            </a>
            <p className="text-neutral-500 text-sm mt-4">
              I typically respond within 24 hours.
            </p>
          </div>
        </div>
      </Section>

      {/* What Happens Next Section */}
      <Section>
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl text-center text-neon-pink mb-12">
            What to expect
          </h2>
          <div className="space-y-6">
            {[
              {
                number: 1,
                title: 'We have a conversation',
                description: "We'll talk about what you're building — where you are, what you're trying to achieve, and what's getting in the way.",
                color: 'neon-lime'
              },
              {
                number: 2,
                title: 'I ask the right questions',
                description: "I'll help you see the full picture — your users, your service, your operations — and where the real opportunities are.",
                color: 'neon-orange'
              },
              {
                number: 3,
                title: 'We agree on a way forward',
                description: "If it's a good fit, we'll agree on scope, a way of working, and what success looks like.",
                color: 'neon-pink'
              },
              {
                number: 4,
                title: 'We build it right',
                description: "I work alongside you until the thing works. You'll know something has changed.",
                color: 'neon-purple'
              },
            ].map((step) => (
              <div key={step.number} className="flex gap-4 items-start">
                <div className={`flex-shrink-0 w-12 h-12 rounded-full bg-${step.color}/20 border border-${step.color}/50 text-${step.color} flex items-center justify-center text-xl`}>
                  {step.number}
                </div>
                <div>
                  <h3 className={`text-xl font-semibold text-${step.color} mb-2`}>
                    {step.title}
                  </h3>
                  <p className="text-neutral-400">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* Honesty Footer */}
      <Section background="gray">
        <div className="max-w-2xl mx-auto">
          <div className="bg-dark-800 border border-neon-orange/30 rounded-xl p-8 text-center">
            <p className="text-lg text-neutral-400">
              I work with a small number of clients so I can give proper attention to each. If we're not the right fit, I'll tell you honestly.
            </p>
          </div>
        </div>
      </Section>
    </>
  )
}
